/**
 * @file 底部
 * @author chenyuyang
 */
import React from 'react';
import PropTypes from 'prop-types';
import {withRouter} from 'react-router-dom';
import {recordProxy} from '../../util';
import './index.less';
import qqQrCode from '../../asset/img/qq-qrcode-20220729.png';
import logo from './imgs/logo.png';
import needLoginList from '../../constants/needLoginList';

const navList = [
    // {
    //     title: '认证资质',
    //     routerPath: '/attest'
    // },
    {
        title: '帮助中心',
        routerPath: '/help'
    },
    {
        title: '常用号码',
        routerPath: '/yellow_page/10'
    },
    {
        title: '合作伙伴',
        routerPath: '/partner'
    },
    {
        title: '问题反馈',
        routerPath: '/feedback',
        needLogin: true
    },
    // {
    //     title: '认证版本',
    //     routerPath: ''
    // }
    {
        title: '百度营销',
        url: 'http://e.baidu.com/?refer=1261',
    },
];
class Footer extends React.Component<any, any> {
    static propTypes = {
        userInfo: PropTypes.object,
        location: PropTypes.object,
        history: PropTypes.object
    };
    constructor(props: any) {
        super(props);
        this.state = {
            amplify: false,
            year: new Date().getFullYear()
        };
    }
    clicker = (scale: boolean) => {
        this.setState({
            amplify: scale,
        });
    };
    login = () => {
        const isDev = window.location.href.indexOf('haoma.baidu.com') > -1 ? false : true;
        const ele = document.createElement('a');
        ele.href = `https://passport${isDev ? '.qatest' : ''}.baidu.com/v2/?login&u=${
            window.location.href
        }`;
        ele.click();
    };
    jump = (item: any) => {
        const pathname = item.routerPath;
        if (pathname) {
            recordProxy('newFooter', 'click', pathname.replace('/', ''));
            const {hasLogin} = this.props;
            if (needLoginList.includes(pathname) && !hasLogin) {
                this.login();
            } else {
                pathname && this.props.history.push(pathname + '?pagef=bottomfooter');
            }
        } else {
            recordProxy('newFooter', 'click', item.url);
            const ele = document.createElement('a');
            ele.href = item.url;
            ele.setAttribute('target', '_blank');
            ele.click();
        }
    };
    render() {
        const {amplify, year} = this.state;
        return (
            <div className="comp-footer">
                <div className="footer-info-wrapper">
                    <div className="footer-info">
                        <img className="logo" src={logo}></img>
                        <div className="info-list">
                            {navList.map((item: any, index: number) => {
                                return (<a key={index} className="list-item" onClick={() => this.jump(item)}>
                                    {item.title}</a>);
                            })}
                        </div>
                        <div className="qr-code-wrapper" onClick={() => this.clicker(true)}>
                            <img className="qr-code" src={qqQrCode}></img>
                            <div className="qr-code-info">QQ群号：725854778</div>
                        </div>
                    </div>
                </div>
                <div className="footer-copyright">
                    Copyright © {year} Baidu, Inc.ALL Rights Reserved
                </div>
                {amplify && <div className={'amplify'} onClick={() => this.clicker(false)}>
                    <img
                        src={qqQrCode}
                        className="scale-qr-code"
                        alt=""
                    />
                </div>}
            </div>
        );
    }
}
export default withRouter(Footer);